import React from 'react';

const DebugInfo = () => {
  // Only show when debug=true in URL or in test mode
  const showDebug = window.location.search.includes('debug=true') || process.env.NODE_ENV === 'test';
  
  if (!showDebug) {
    return null;
  }

  const envVars = Object.keys(process.env)
    .filter(key => key.startsWith('REACT_APP_'))
    .reduce((obj, key) => {
      obj[key] = process.env[key] ? `${process.env[key].substring(0, 20)}...` : 'MISSING';
      return obj;
    }, {});

  return (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      background: '#000',
      color: '#fff',
      padding: '10px',
      borderRadius: '5px',
      fontSize: '12px',
      zIndex: 9999,
      maxWidth: '300px',
      fontFamily: 'monospace'
    }}>
      <h4>Debug Info</h4>
      <p><strong>NODE_ENV:</strong> {process.env.NODE_ENV}</p>
      <p><strong>Build Time:</strong> {new Date().toISOString()}</p>
      <h5>Environment Variables:</h5>
      <pre>{JSON.stringify(envVars, null, 2)}</pre>
      <p style={{ fontSize: '10px', marginTop: '10px' }}>
        Add ?debug=true to URL to show this in production
      </p>
    </div>
  );
};

export default DebugInfo;
